import React from 'react'
import { i18n } from '@fs/zion-locale'
import { DocumentPhoto, LogoFamilysearch, PlaceWorld } from '@fs/zion-icon'

export default {
  // service api calls bases and endpoint URLs
  tfBase: '/service/tree/tf',
  linksBase: '/service/tree/links',
  treeData: '/service/tree/tree-data',
  memoryUploadUrl: '/service/memories/manager/artifacts/files?filename=', // URL to upload a memory
  sourceMemoryUrlPrefix: 'http://familysearch.org/patron/source/photoId/', // URL format for saving memory id to Sources database

  // error codes and error messages
  SC_BAD_REQUEST: 400,
  SC_NOT_FOUND: 404,
  SC_GONE: 410,
  INVALID_CHARACTER: 'Invalid Character',

  // Global values
  PAGE_SIZE: 50, // SourceBox page size
  PAGES_TO_SEARCH: 25,
  MAX_FOLDERS: 300,
  SOURCE_MIN_TITLE_LENGTH: 1,
  SOURCE_MAX_TITLE_LENGTH: 255,
  SOURCE_MAX_WEB_URL_LENGTH: 1500,
  SOURCE_MAX_CITATION_LENGTH: 1000,
  SOURCE_MAX_NOTE_LENGTH: 10000,
  SOURCE_MAX_REASON_LENGTH: 1500,

  // source reference types
  SOURCE_TYPE_DEFAULT: 'DEFAULT',
  SOURCE_TYPE_USER_UPLOADED: 'USER_UPLOADED',
  SOURCE_TYPE_FSREADONLY: 'FSREADONLY',
  SOURCE_TYPE_IGI: 'IGI',
  SOURCE_TYPE_ASIAN_DATA_ENTRY: 'ASIAN_DATA_ENTRY',
  SOURCE_TYPE_LEGACY: 'LEGACY',

  // FiltersDrawer on ChangeLog Page
  FILTER_ALL_CHANGES: 'ALL CHANGES',
  FILTER_DATE: 'EVENT',
  FILTER_TITLE: 'TITLE',
  FILTER_URL: 'URI',
  FILTER_CITATION: 'CITATION',
  FILTER_NOTES: 'NOTES',
  FILTER_MEMORY: 'MEMORY',
  FILTER_SOURCE_CREATED: 'SOURCE CREATED',

  // Source Fields
  EDIT_FIELD_DATE: 'DATE',
  EDIT_FIELD_TITLE: 'TITLE',
  EDIT_FIELD_WEB_PAGE: 'WEB_PAGE',
  EDIT_FIELD_CITATION: 'CITATION',
  EDIT_FIELD_NOTES: 'NOTES',
  EDIT_FIELD_REASON: 'REASON',
  EDIT_WEB_PAGE_URL: 'URL',
  EDIT_WEB_PAGE_MEMORY: 'MEMORY',

  // Buttons that can be shown on the source panel
  SOURCE_BUTTON_ATTACHED_TO: 'SOURCE_BUTTON_ATTACHED_TO',
  SOURCE_BUTTON_COPY_TO_SOURCEBOX: 'SOURCE_BUTTON_COPY_TO_SOURCEBOX',
  SOURCE_BUTTON_DETACH: 'SOURCE_BUTTON_DETACH',
  SOURCE_BUTTON_EDIT: 'SOURCE_BUTTON_EDIT',
  SOURCE_BUTTON_GO_TO_SOURCEBOX: 'SOURCE_BUTTON_GO_TO_SOURCEBOX',
  SOURCE_BUTTON_REPORT_ABUSE: 'SOURCE_BUTTON_REPORT_ABUSE',
  SOURCE_BUTTON_REVIEW_ATTACHMENTS: 'SOURCE_BUTTON_REVIEW_ATTACHMENTS',
  SOURCE_BUTTON_REMOVE: 'SOURCE_BUTTON_REMOVE',
  SOURCE_BUTTON_TAG: 'SOURCE_BUTTON_TAG',
  SOURCE_BUTTON_VIEW: 'SOURCE_BUTTON_VIEW',

  getSourceIcon: (type, single) => {
    let Icon
    switch (type) {
      case 'USER_UPLOADED':
        Icon = <DocumentPhoto size={single ? 'sm' : 'xs'} />
        break
      case 'FSREADONLY':
      case 'IGI':
      case 'ASIAN_DATA_ENTRY':
      case 'LEGACY':
        Icon = <LogoFamilysearch size={single ? 'sm' : 'xs'} />
        break
      default:
        Icon = <PlaceWorld size={single ? 'sm' : 'xs'} />
    }
    return Icon
  },

  localizeDate: (time) => {
    const timeStamp = new Date(time)?.getTime()
    // make sure we have a timeStamp
    if (!timeStamp) return time
    const dateConfig = {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }
    const date = new Date(parseInt(timeStamp, 10))
    return date.toLocaleDateString(i18n.language, dateConfig)
  },

  calculateAllFolderSourceCount: (folders) => {
    return folders?.reduce((acc, folder) => acc + Number(folder?.sourceCount ?? 0), 0) ?? 0
  },

  // TODO: Need to add URLs for other languages once we have them available. (For now it only shows the link to this page if running English)
  getTranslatedHelpUrl: () => {
    let url
    switch (i18n.language) {
      case 'en':
        url = 'https://www.familysearch.org/en/blog/familysearch-updates-enhance-your-experience'
        break
      default:
        // Default to English
        url = 'https://www.familysearch.org/en/blog/familysearch-updates-enhance-your-experience'
    }
    return url
  },
}
